import CitizenFokontanySearch from './CitizenFokontanySearch';

export default CitizenFokontanySearch;
